import { useState } from 'react';
import { PlatformOption } from '../types/ApiTypes';
import { ReviewOptionsProps } from '../types/PropsTypes';
import { PlatformButton } from './PlatformButton';
import { getPlatformOptionReviewType } from '../services/ReviewProcessService';
import { Button } from '@mantine/core';

export function ReviewOptions({
  platformOptions,
  onSelect,
}: ReviewOptionsProps): JSX.Element {
  const [showAll, setShowAll] = useState(false);

  const priorityOptions = platformOptions.filter(
    (platformOption) => platformOption.secondary_priority,
  );
  const nonPriorityOptions = platformOptions.filter(
    (platformOption) => !platformOption.secondary_priority,
  );

  return (
    <div className="centered-stack">
      {priorityOptions.map((writtenButton: PlatformOption) => (
        <PlatformButton
          key={writtenButton.name}
          writtenButton={writtenButton}
          onClick={() =>
            onSelect(
              writtenButton.DOMid,
              writtenButton.url,
              getPlatformOptionReviewType(writtenButton.DOMid),
            )
          }
        />
      ))}
      {nonPriorityOptions.length > 0 ? (
        showAll ? (
          nonPriorityOptions.map((writtenButton: PlatformOption) => (
            <PlatformButton
              key={writtenButton.name}
              writtenButton={writtenButton}
              onClick={() =>
                onSelect(
                  writtenButton.DOMid,
                  writtenButton.url,
                  getPlatformOptionReviewType(writtenButton.DOMid),
                )
              }
            />
          ))
        ) : (
          <Button
            radius={'lg'}
            my={'lg'}
            color="gray"
            onClick={() => setShowAll(true)}
          >
            More Options
          </Button>
        )
      ) : null}
    </div>
  );
}
